import { Icon } from "PFComponents/icon";
import Toggle from "PFComponents/toggle/toggle";
import Tooltip from "PFComponents/tooltip/tooltip";
import { PageTarget } from "PFTypes/saved_filters";
import React from "react";
import { useTranslation } from "react-i18next";

import { useSavedViewsContext } from "../../components/filters/saved_views_context/saved_views_context";
import { ProjectsCalendarData } from "./overview/context/booking_overview_context.types";
import { useBookingsOverviewContext } from "./overview/context/bookings_overview_context";
import css from "./toolbar.module.scss";

type ToolbarChildrenFiltersToggleProps = {
  viewsKey: PageTarget | null;
};

export const ToolbarChildrenFiltersToggle = ({ viewsKey }: ToolbarChildrenFiltersToggleProps) => {
  const { t } = useTranslation("bookingModule");
  const {
    calendarData: { childrenFiltersEnabled, setChildrenFiltersEnabled }
  } = useBookingsOverviewContext<ProjectsCalendarData>();
  const { setSelectedViewId } = useSavedViewsContext(viewsKey);

  if (!setChildrenFiltersEnabled) {
    return <>{t("filters.rolesAndAuditRoles")}</>;
  }

  const handleChange = (enabled: boolean): void => {
    setSelectedViewId(null);
    setChildrenFiltersEnabled(enabled);
  };

  return (
    <div className={css.childrenFiltersToggleContainer}>
      <Toggle
        description={t("filters.rolesAndAuditRoles")}
        checked={childrenFiltersEnabled}
        onChange={handleChange}
      />
      <Tooltip content={t("filters.childrenFiltersInfo")}>
        <div className={css.childrenFiltersToggleTooltipIconWrapper}>
          <Icon name="info" />
        </div>
      </Tooltip>
    </div>
  );
};
